import { useMutation } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { queryKeys } from '../../../../api/queryKeys';
import { queryClient } from '../../../../../../config/queryClient';
import { useClientId } from '../../../../../_hooks/useClientId';
import { useFpId } from '../../../../hooks/useFpId';
import { Body } from '../tabs/Beneficiaries/components/EditAssetForm/components/EquityCompensationEditAssetForm/EquityCompensationEditAssetForm.meta';

interface Params {
  body: Body;
}

const saveEquityCompensation = (clientId: number) => ({ body }: Params) => {
  return authFetch(`/Consumer/AccountBeneficiariesUpdateV2/SaveEquityCompensationBeneficiariesV2`, {
    method: 'POST',
    ...httpBodyOptions({ ...body, clientId }, true),
  });
};

export const useEquityCompensationMutation = () => {
  const clientId = useClientId();

  const fpId = useFpId();

  return useMutation(saveEquityCompensation(clientId), {
    async onSuccess() {
      const queryKey = queryKeys.estatePlanningExplanation(clientId, fpId);

      await queryClient.invalidateQueries(queryKey);
    },
  });
};
